import React from 'react';

// Types
import { WorkspaceMeeting } from 'Shared/types/WorkspaceMeeting.type';
import { ItemType } from 'Shared/constants/types';

// Utils
import { formatDate, isDateInCurrentYear } from 'Shared/utils/DateTime.utils';

// Components
import Checkmark from 'Shared/components/Checkmark/Checkmark';
import { WpTooltip, WpTooltipContent, WpTooltipTrigger } from 'Wpds/components/tooltip';

type Props = {
  meetingItem;
  workspaceMeeting: WorkspaceMeeting;
};

const SnapshotMeetingItemCheckmarkIcon = ({ meetingItem, workspaceMeeting }: Props) => {
  const { itemType, completedAt } = meetingItem;
  const itemTypeString = itemType === ItemType.actionItem ? 'action item' : 'topic';
  const isCompleted = Boolean(completedAt);

  const completeIconDateFormatString = `MMMM Do${isDateInCurrentYear(workspaceMeeting.startTime) ? '' : ', YYYY'}`;
  const completeIconTooltipText = `This ${itemTypeString} was ${
    isCompleted ? 'complete' : 'incomplete'
  } on ${formatDate(workspaceMeeting.startTime, completeIconDateFormatString)}`;

  return (
    <WpTooltip placement="top">
      <WpTooltipTrigger>
        <div>
          <Checkmark isCompleted={isCompleted} />
        </div>
      </WpTooltipTrigger>
      <WpTooltipContent>{completeIconTooltipText}</WpTooltipContent>
    </WpTooltip>
  );
};

export default SnapshotMeetingItemCheckmarkIcon;
